/**
 * @generated SignedSource<<624bc641f440698c57ee4e193aa1f0fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SuppressTimeRegOnProjectWarningInput = {
  projectId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type suppressTimeRegOnProjectWarningMutation$variables = {
  input: SuppressTimeRegOnProjectWarningInput;
};
export type suppressTimeRegOnProjectWarningMutation$data = {
  readonly suppressTimeRegOnProjectWarning: {
    readonly clientMutationId: string | null;
  } | null;
};
export type suppressTimeRegOnProjectWarningMutation = {
  variables: suppressTimeRegOnProjectWarningMutation$variables;
  response: suppressTimeRegOnProjectWarningMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressTimeRegOnProjectWarningPayload",
    "kind": "LinkedField",
    "name": "suppressTimeRegOnProjectWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressTimeRegOnProjectWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressTimeRegOnProjectWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "12417de15adc89aa7bf819218013430c",
    "id": null,
    "metadata": {},
    "name": "suppressTimeRegOnProjectWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressTimeRegOnProjectWarningMutation(\n  $input: SuppressTimeRegOnProjectWarningInput!\n) {\n  suppressTimeRegOnProjectWarning(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3810a21558a0a8e71000f2e69cd355c2";

export default node;
